export const iconFontAwesomeHumanitarianFlag = (
	<i className="fa-solid fa-flag"></i>
);
